import React, { useMemo, useState } from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { FormEditFinalCustomers } from './FormEditFinalCustomers';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { Button } from '../buttons/buttons';

export const ModalEditFinalCustomers = ({ show, finalCustomerId, handleClose }) => {
  const formName = useMemo(() => uuid(), []);
  const { translate: t } = useDictionaryTranslation();
  const [isLoading, setIsLoading] = useState();

  const closeModal = ({ reloadData = false, customerData } = {}) => {
    handleClose(reloadData, customerData);
  };

  const onFinishFormAction = async result => {
    setIsLoading(true);
    try {
      const customerData = await result;
      closeModal({ reloadData: true, customerData });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={t(finalCustomerId ? 'editFinalCustomer' : 'createFinalCustomer')}
      centered
      width="90%"
      height="70%"
      onCancel={closeModal}
      destroyOnClose
      open={show}
      footer={
        <div>
          <Button form={formName} key="submit" htmlType="submit" type="primary" disabled={isLoading}>
            {t('save')}
          </Button>
        </div>
      }
    >
      <FormEditFinalCustomers finalCustomerId={finalCustomerId} onFinish={onFinishFormAction} formName={formName} />
    </Modal>
  );
};

ModalEditFinalCustomers.propTypes = {
  finalCustomerId: PropTypes.string,
  show: PropTypes.bool,
  handleClose: PropTypes.func,
};
